module.exports = __webpack_public_path__ + "img/arrow-right.edb38e3d.svg";